import { put, take } from 'redux-saga/effects';

import { EXTRACT_AND_MODIFY_URL, SAVE_URL_PARAMS } from './actions';
import parseUrlQuery from 'lib/parseUrlQuery';


function* extractAndModify() {
  while (true) {
    yield take(EXTRACT_AND_MODIFY_URL);
    console.time('extractAndModify#extractAndModify')

    const query = yield parseUrlQuery();

    yield put({ type: SAVE_URL_PARAMS, data: query });
    console.timeEnd('extractAndModify#extractAndModify')
  }
}


export default extractAndModify;
